import { RouteObject } from "react-router-dom";
import routePaths from "./../../constants/routes";
import ProtectedRoutes from "utils/ProtectedRoutes";
import React from "react";
import Loader from "components/UI/Loader";

const FaxContainer = React.lazy(() => import("pages/Fax"));

export const faxRoutes: RouteObject[] = [
	{
		path: routePaths.FAX.__PATH,
		element: (
			<ProtectedRoutes>
				<React.Suspense fallback={<Loader />}>
					<FaxContainer />
				</React.Suspense>
			</ProtectedRoutes>
		),
	},
];
